import { InjectionToken } from "@angular/core";

export const PUSHER_TOKEN = new InjectionToken<{ key: string, app_id: string, secret: string, cluster: string, pusherApiUrl: string }>('PUSHER_TOKEN');